import { useQuery } from '@tanstack/react-query';
import { type ChangeOrderSummaryVariables, getChangeOrderSummary } from '@/api/Sherpa/ChangeOrder/index';
import { CACHE_TIME } from '@/constants';
import { SherpaProjectReactQueryKey } from '@/constants/ReactQueryKeys';

export const useChangeOrderSummary = ({ projectId }: ChangeOrderSummaryVariables) => {
  return useQuery({
    queryKey: [SherpaProjectReactQueryKey.GET_CHANGE_ORDER_SUMMARY],
    queryFn: () => getChangeOrderSummary({ projectId }),
    staleTime: CACHE_TIME,
    cacheTime: CACHE_TIME,
  });
};
